import styled from "styled-components";
import {
  DefaultParagraphLargeFactory,
  DefaultParagraphSmallFactory,
  DefaultTitleLargeFactory,
} from "../../Habitacional/core/Typograph/Typograph.Style";

const flexColumn = {
  display: "flex",
  flexDirection: "column",
};

export const CoverageSectionContainer = styled.section(({ theme }) => ({
  backgroundColor: theme.color.neutral["08"],
  marginBottom: "0 !important",
  paddingTop: "40px",
  paddingBottom: "40px",

  [theme.breakpoint.lg()]: {
    paddingTop: "60px",
    paddingBottom: "60px",
  },
}));

export const CoverageSectionContent = styled.div(() => ({
  ...flexColumn,
  gap: "60px",
}));

export const CoverageSectionBlock = styled.div(() => ({
  ...flexColumn,
  gap: "12px",
}));

export const ConverageSectionBlockTitle = styled.h2(({ theme }) => ({
  ...DefaultTitleLargeFactory({ theme }),
  color: theme.color.neutral["02"],
}));

export const ConverageSectionBlockDescription = styled.p(({ theme }) => ({
  ...DefaultParagraphLargeFactory({ theme }),
  color: theme.color.neutral["02"],
  lineHeight: "160%",

  strong: {
    ...DefaultParagraphLargeFactory({ theme }),
    fontWeight: "600",
  },
}));

export const CoverageSectionList = styled.div(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "32px",

  [theme.breakpoint.lg()]: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: "60px",
  },
}));

export const CoverageSectionItem = styled.div(({ theme }) => ({
  ...flexColumn,
  maxWidth: "578px",
  width: "100%",
  minHeight: "auto",
  gap: "16px",
  paddingLeft: "16px",
  borderLeft: `3px solid ${theme.color.brandPrimary.light}`,

  [theme.breakpoint.xl()]: {
    maxWidth: "100%",
  },
}));

export const CoverageSectionItemTitle = styled.h2(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: "16px",

  svg: {
    width: "60px",
    height: "60px",
  },

  span: {
    ...DefaultParagraphLargeFactory({ theme }),
    flex: 1,
    fontWeight: "600",
  },
}));

export const CoverageSectionItemDescription = styled.p(({ theme }) => ({
  ...DefaultParagraphSmallFactory({ theme }),
  fontWeight: "400",
}));

export const CoverageSectionFooter = styled.div(() => ({
  ...flexColumn,
  alignItems: "center",
  width: "100%",
}));
